import { initializeCkeditor5 } from '../../shared/ckeditor5_setup'

class addFields {
    // This executes when the function is instantiated.
    constructor() {
        this.links = document.querySelectorAll('.add_fields')
        this.iterateLinks()
    }

    iterateLinks() {
        // If there are no links on the page, stop the function from executing.
        if (this.links.length === 0) return
        // Loop over each link on the page. A page could have multiple nested forms.
        this.links.forEach(link => {
            link.addEventListener('click', e => {
                this.handleClick(link, e)
            })
        })
    }

    handleClick(link, e) {
        // Stop the function from executing if a link or event were not passed into the function.
        if (!link || !e) return
        // Prevent the browser from following the URL.
        e.preventDefault()
        // Save a unique timestamp to ensure the key of the associated array is unique.
        let time = new Date().getTime()
        // Save the data id attribute into a variable. This corresponds to `new_object.object_id`.
        let linkId = link.dataset.id
        // Create a new regular expression needed to find any instance of the `new_object.object_id` used in the fields data attribute if there's a value in `linkId`.
        let regexp = linkId ? new RegExp(linkId, 'g') : null
        // Replace all instances of the `new_object.object_id` with `time`, and save markup into a variable if there's a value in `regexp`.
        let newFields = regexp ? link.dataset.fields.replace(regexp, time) : null
        // Add the new markup to the form if there are fields to add.
        let element = link.dataset.element
        if (newFields) {
            if (element === "tr") {
                link.closest(element).insertAdjacentHTML('beforebegin', newFields)
            } else if (element === "div") {
                link.insertAdjacentHTML('beforebegin', newFields)
            } else {
                link.insertAdjacentHTML('beforebegin', newFields)
            }
            // Newly-inserted markup isn't covered by ckeditor5_setup.js's own turbo:load listener
            // (nothing re-fires turbo:load just because a nested field got added), so a
            // dynamically-added .ckeditor5 textarea would otherwise stay a plain textarea forever.
            // Called directly (not by re-dispatching turbo:load) since several of this app's other
            // turbo:load-bound initializers re-attach listeners on every call without an
            // idempotency guard - re-firing the event here would duplicate those, not just this.
            initializeCkeditor5()
        }
    }
}

// Wait for turbo to load, otherwise `document.querySelectorAll()` won't work
window.addEventListener('turbo:load', () => new addFields())
// Also support turbolinks for backwards compatibility
window.addEventListener('turbolinks:load', () => new addFields())